import gql from 'graphql-tag';

/**
 * GQL Update Preventive Maintenance Task Mutation
 */

export const updatePMTaskMutation = gql`
  mutation updatePMTaskMutation($task: UpdateTask!) {
    updateTask(task: $task) {
      id
      updatedAt
    }
  }
`;
